import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import HomeSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/home.svg';
import BathSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/bath.svg';
import HammerSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/hammer.svg';
import LocationLineSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/location-line.svg';
import CalculatorSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/calculator.svg';
import KeySvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/key.svg';
import { FaqCategoryMenuStyles } from './FaqCategoryMenu.styled';

const FaqCategoryMenu = () => {
  const router = useRouter();

  return (
    <FaqCategoryMenuStyles>
      <ul className="faq-category-nav">
        <li>
          <Link
            href="/faq/manufactured-home-buying"
            className={
              router?.asPath.startsWith('/faq/manufactured-home-buying')
                ? 'current'
                : ''
            }
          >
            <HomeSvg /> Home Buying
          </Link>
        </li>
        <li>
          <Link
            href="/faq/manufactured-home-features"
            className={
              router?.asPath.startsWith('/faq/manufactured-home-features')
                ? 'current'
                : ''
            }
          >
            <BathSvg /> Home Features
          </Link>
        </li>
        <li>
          <Link
            href="/faq/manufactured-home-building"
            className={
              router?.asPath.startsWith('/faq/manufactured-home-building')
                ? 'current'
                : ''
            }
          >
            <HammerSvg /> Home Building
          </Link>
        </li>
        <li>
          <Link
            href="/faq/manufactured-home-delivery"
            className={
              router?.asPath.startsWith('/faq/manufactured-home-delivery')
                ? 'current'
                : ''
            }
          >
            <LocationLineSvg /> Home Delivery
          </Link>
        </li>
        <li>
          <Link
            href="/faq/manufactured-home-financing"
            className={
              router?.asPath.startsWith('/faq/manufactured-home-financing')
                ? 'current'
                : ''
            }
          >
            <CalculatorSvg /> Home Financing
          </Link>
        </li>
        <li>
          <Link
            href="/faq/manufactured-homeownership"
            className={
              router?.asPath.startsWith('/faq/manufactured-homeownership')
                ? 'current'
                : ''
            }
          >
            <KeySvg /> Homeownership
          </Link>
        </li>
      </ul>
    </FaqCategoryMenuStyles>
  );
};

export default FaqCategoryMenu;
